import React from 'react';
import Button from '../../../../components/atoms/Button/Button';

/**
 * DashCard
 * --------
 * Renderiza una card de incidencias en el detalle de cierre de turno.
 *
 * Props:
 *  - card       {Object}   Configuración de la card (CardsConfig.js)
 *  - datos      {Array}    Arreglo de registros ya resuelto para esta card
 *  - onVerDetalle {Function} Callback al presionar "Ver detalle"
 */
const DashCard = ({ card, datos = [], onVerDetalle }) => {
    const cantidad = datos.length;

    return (
        <div
            className="dashCard"
            style={{ '--card-accent': card.color }}
        >
            <div className="dashCardIcon">
                <img src={card.icono} alt={card.titulo} />
            </div>

            <div className="dashCardBody">
                <div className="dashCardTitulo">{card.titulo}</div>

                {card.conteoGrupos ? (
                    <div className="dashCardConteoDoble">
                        {card.conteoGrupos.map((grupo, i) => (
                            <React.Fragment key={grupo.label}>
                                {i > 0 && <div className="dashCardConteoSep" />}
                                <div className="dashCardConteoItem">
                                    <span className="dashCardConteoNum">
                                        {grupo.calc
                                            ? grupo.calc(datos.filter(grupo.cond))
                                            : datos.filter(grupo.cond).length}
                                    </span>
                                    <span className="dashCardConteoLabel">{grupo.label}</span>
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                ) : (
                    <div className="dashCardConteo">{cantidad}</div>
                )}
            </div>

            <Button
                onClick={() => onVerDetalle(card)}
                width="100%"
                className="dashCardBtn"
            >
                Ver detalle
            </Button>
        </div>
    );
};

export default DashCard;
